
import { ShoppingBag, Package, TrendingUp, Users, Smartphone, BarChart3, Truck, Store, CreditCard, Tag } from 'lucide-react';
import type { Product } from './types';

export const retailProducts: Product[] = [
  {
    id: 'omnichannel-retail-platform',
    title: 'Omnichannel Retail Management Platform',
    subtitle: 'Complete retail operations solution',
    description: 'Comprehensive retail platform with inventory management, point-of-sale integration, customer analytics, and omnichannel experience for UK retailers.',
    icon: Store,
    image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Retail & Fashion',
    status: 'Available',
    businessTypes: ['#retail', '#ecommerce', '#multi-channel', '#sme', '#enterprise'],
    features: [
      'Unified Inventory Management Across Channels',
      'Cloud-Based EPOS System & Payment Processing',
      'Customer Analytics & Behaviour Tracking',
      'Loyalty Programme Management & Rewards',
      'Supply Chain Management & Vendor Relations',
      'Multi-Store Management & Reporting',
      'E-commerce Integration & Online Store',
      'Staff Management & Performance Analytics',
      'Financial Reporting & Business Intelligence',
      'Mobile App & Customer Engagement Tools',
      'UK VAT Management & Tax Reporting',
      'GDPR Compliance & Data Protection Tools'
    ],
    pricing: { setup: 45000, monthly: 2070 },
    color: 'from-blue-500 to-indigo-600'
  },
  {
    id: 'fashion-design-production',
    title: 'Fashion Design & Production Management',
    subtitle: 'Complete fashion lifecycle platform',
    description: 'End-to-end fashion management with design tools, production planning, supplier management, and trend analytics.',
    icon: ShoppingBag,
    image: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Retail & Fashion',
    status: 'Available',
    businessTypes: ['#fashion', '#design', '#manufacturing', '#boutique', '#apparel'],
    features: [
      'Design Portfolio & Collection Management',
      'Pattern Making & Technical Design Tools',
      'Production Planning & Manufacturing Coordination',
      'Supplier Management & Quality Control',
      'Trend Analysis & Market Research Integration',
      'Size Chart Management & Grading',
      'Costing Analysis & Profit Optimization',
      'Sample Management & Approval Workflows',
      'Sustainability Tracking & Reporting',
      'Brand Management & Marketing Integration'
    ],
    pricing: { setup: 48000, monthly: 2208 },
    color: 'from-pink-500 to-purple-600'
  },
  {
    id: 'inventory-supply-chain',
    title: 'Inventory & Supply Chain Optimization',
    subtitle: 'Smart inventory management solution',
    description: 'Advanced inventory management with demand forecasting, automated reordering, supplier integration, and logistics optimization.',
    icon: Package,
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Retail & Fashion',
    status: 'Available',
    businessTypes: ['#retail', '#manufacturing', '#logistics', '#enterprise', '#inventory'],
    features: [
      'Real-Time Inventory Tracking & Management',
      'Demand Forecasting & Predictive Analytics',
      'Automated Reordering & Purchase Management',
      'Supplier Integration & Performance Monitoring',
      'Warehouse Management & Location Tracking',
      'Multi-Channel Inventory Synchronization',
      'Cost Analysis & Profit Margin Optimization',
      'Returns Management & Reverse Logistics',
      'Quality Control & Inspection Workflows',
      'Business Intelligence & Reporting Dashboard'
    ],
    pricing: { setup: 42000, monthly: 1932 },
    color: 'from-emerald-500 to-green-600'
  },
  {
    id: 'customer-analytics-personalization',
    title: 'Customer Analytics & Personalization Engine',
    subtitle: 'AI-powered customer intelligence platform',
    description: 'Advanced customer analytics with personalization engine, behavioral tracking, and targeted marketing automation.',
    icon: Users,
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Retail & Fashion',
    status: 'Available',
    businessTypes: ['#retail', '#ecommerce', '#analytics', '#marketing', '#enterprise'],
    features: [
      'Customer Behavior Analytics & Segmentation',
      'AI-Powered Product Recommendations',
      'Personalized Marketing Campaign Automation',
      'Customer Journey Mapping & Optimization',
      'Predictive Customer Lifetime Value Analysis',
      'Cross-Channel Customer Profile Unification',
      'A/B Testing & Conversion Optimization',
      'Loyalty Program Analytics & Optimization',
      'Churn Prediction & Retention Strategies',
      'Real-Time Personalization & Dynamic Content'
    ],
    pricing: { setup: 50000, monthly: 2300 },
    color: 'from-violet-500 to-purple-600'
  }
];
